import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import SetupChargesAddEdit from "./SetupChargesAddEdit";
import SetupChargesTable from "./SetupChargesTable";

function SetupChargesTableContainer(props) {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}/edit/:id`}>
          <SetupChargesAddEdit />
        </Route>
        <Route path={`${path}/add`}>
          <SetupChargesAddEdit />
        </Route>
        <Route path={`${path}`}>
          <SetupChargesTable />
        </Route>
      </Switch>
    </>
  );
}

export default SetupChargesTableContainer;
